import { Category } from './category';

export class CategorySelectDialog {
  Categories: Array<Category>;
}
